import React, { useContext, useState } from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Button, Col, Row } from "components/bootstrap";
import InputForm from "forwarder/inputs/InputForm";
import InputsTable from "forwarder/inputs/InputsTable";
import { ForwarderInputsActions } from "forwarder/stores/ForwarderInputsStore";
import { ForwarderWizardContext } from "../ForwarderWizardProvider";
import { StyledTitle } from "../StyledWizardComponents";
const StyledAddInputButton = styled(Button)`
  display: block;
  margin-bottom: 20px;
`;
const ACTIONS = { NEW: "new", LIST: "list", EDIT: "edit" };
const InputsManagement = ({ inputProfile, onInputsCreated }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const { inputTypes, inputDescriptions } = useContext(ForwarderWizardContext);
  const [inputs, setInputs] = useState([]);
  const [action, setAction] = useState(ACTIONS.NEW);
  const [selectedInput, setSelectedInput] = useState(void 0);
  const toggleNewInputForm = () => {
    setAction(action === ACTIONS.NEW ? ACTIONS.LIST : ACTIONS.NEW);
  };
  const showEditInputForm = (input) => {
    setSelectedInput(input);
    setAction(ACTIONS.EDIT);
  };
  const hideEditInputForm = () => {
    setSelectedInput(void 0);
    setAction(ACTIONS.LIST);
  };
  const handleInputCreate = (input) => {
    ForwarderInputsActions.create(inputProfile.id, input).then((persistedInput) => {
      setInputs([...inputs, persistedInput]);
      toggleNewInputForm();
    });
  };
  const handleInputUpdate = (updatedInput) => {
    if (!selectedInput) {
      throw new Error("Tried to update input but no input was selected.");
    }
    ForwarderInputsActions.update(inputProfile.id, selectedInput.id, updatedInput).then((persistedInput) => {
      setInputs(inputs.map((input) => input.id === persistedInput.id ? persistedInput : input));
      hideEditInputForm();
    });
  };
  const handleInputDelete = (input) => {
    if (window.confirm(t("inputs_management.delete_confirm", { title: input.title }))) {
      ForwarderInputsActions.delete(inputProfile.id, input).then(() => {
        setInputs(inputs.filter((i) => i.id !== input.id));
      });
    }
  };
  switch (action) {
    case ACTIONS.NEW:
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledTitle, null, t("inputs_management.add_input", { title: inputProfile.title })), /* @__PURE__ */ React.createElement(
        InputForm,
        {
          action: "create",
          inputTypes,
          inputDescriptions,
          onCancel: toggleNewInputForm,
          onSubmit: handleInputCreate
        }
      )));
    // @ts-expect-error fallthrough is on purpose
    case ACTIONS.EDIT:
      if (selectedInput) {
        return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(StyledTitle, null, /* @__PURE__ */ React.createElement(
          Trans,
          {
            t,
            i18nKey: "inputs_management.edit_input",
            values: {
              title: selectedInput.title,
              type: inputTypes[selectedInput.type],
              profile: inputProfile.title
            },
            components: { small: /* @__PURE__ */ React.createElement("small", null) }
          }
        )), /* @__PURE__ */ React.createElement(
          InputForm,
          {
            action: "edit",
            input: selectedInput,
            inputTypes,
            inputDescriptions,
            onCancel: hideEditInputForm,
            onSubmit: handleInputUpdate
          }
        )));
      }
    // Default to inputs table if selectedInput is not set
    // eslint-disable-next-line no-fallthrough
    default:
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 7 }, /* @__PURE__ */ React.createElement(StyledTitle, null, t("wizard_inputs_management.inputs_in", { title: inputProfile.title })), /* @__PURE__ */ React.createElement(
        InputsTable,
        {
          inputs,
          inputTypes,
          onInputEdit: showEditInputForm,
          onInputDelete: handleInputDelete,
          withActions: true
        }
      ), /* @__PURE__ */ React.createElement(StyledAddInputButton, { onClick: toggleNewInputForm }, t("wizard_inputs_management.add_another")), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onInputsCreated }, t("wizard_inputs_management.save"))));
  }
};
export default InputsManagement;
